/* ============================================================
   OXIFY — Science sections
   Shared by the split oxify-sci-* sections. Loads once per page.
   · champagne particle drift on any [data-particles] canvas
   · count-up numbers on any .osci-numbers band
   Each element is initialised at most once, so re-running boot()
   after a theme-editor section load is safe.
   ============================================================ */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initParticles(cv) {
    if (cv.dataset.oxInit) return;
    cv.dataset.oxInit = '1';
    var ctx = cv.getContext('2d'), w, h, dpr, ps = [], t = 0;
    function sp(any) {
      return { x: Math.random() * w, y: any ? Math.random() * h : h + 20, r: .6 + Math.random() * 2.4,
               s: .1 + Math.random() * .45, d: (Math.random() - .5) * .25, ph: Math.random() * 6.28,
               a: .1 + Math.random() * .45 };
    }
    function size() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(w * h / 30000 * 0.5);
      ps = Array.from({ length: n }, function () { return sp(true); });
    }
    function draw() {
      t += .006;
      ctx.clearRect(0, 0, w, h);
      ps.forEach(function (p, i) {
        if (!reduce) { p.y -= p.s; p.x += p.d + Math.sin(t * 1.4 + p.ph) * .15; }
        if (p.y < -10) ps[i] = sp(false);
        var a = p.a * (.6 + .4 * Math.sin(t * 2 + p.ph));
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 3.4);
        g.addColorStop(0, 'rgba(200,178,130,' + a + ')');
        g.addColorStop(.35, 'rgba(200,178,130,' + a * .35 + ')');
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 3.4, 0, 6.28); ctx.fill();
      });
      if (!reduce) requestAnimationFrame(draw);
    }
    size();
    window.addEventListener('resize', size);
    draw();
  }

  function initCounts(band) {
    if (band.dataset.oxInit) return;
    band.dataset.oxInit = '1';
    var seen = false;
    function run() {
      if (seen) return;
      var r = band.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.85 || r.bottom < 0) return;
      seen = true;
      band.querySelectorAll('.osci-stat-n').forEach(function (el) {
        var raw = el.getAttribute('data-count') || '';
        var m = raw.match(/([^\d]*)([\d.,]+)([^\d]*)$/);
        if (!m) { el.textContent = raw; return; }
        var pre = m[1], suf = m[3], num = parseFloat(m[2].replace(/,/g, ''));
        if (isNaN(num)) { el.textContent = raw; return; }
        var dec = (m[2].split('.')[1] || '').length;
        if (reduce) { el.textContent = raw; return; }
        var t0 = performance.now(), dur = 1800;
        (function tick(now) {
          var p = Math.min(1, (now - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + (num * e).toFixed(dec) + suf;
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      });
    }
    window.addEventListener('scroll', run, { passive: true });
    run();
  }

  /* scroll reveal — items fade/rise in one by one as they enter view.
     Same approach as the home-page legacy section: JS adds .js-reveal so
     content stays visible when JS is off or motion is reduced. */
  var revealIO = null;
  function initReveal() {
    var els = document.querySelectorAll('.osci [data-reveal]:not([data-ox-rev])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.osci').forEach(function (s) { s.classList.add('js-reveal'); });

    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          // stagger by position among its revealing siblings → one-by-one cascade
          var sibs = el.parentElement
            ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-reveal'); })
            : [el];
          var i = Math.max(0, sibs.indexOf(el));
          el.style.transitionDelay = (i * 140) + 'ms';
          el.classList.add('is-in');
          revealIO.unobserve(el);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }

    els.forEach(function (el) { el.setAttribute('data-ox-rev', '1'); revealIO.observe(el); });
  }

  function boot() {
    document.querySelectorAll('[data-particles] canvas').forEach(initParticles);
    document.querySelectorAll('.osci-numbers').forEach(initCounts);
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();